<template>
    <v-dialog v-model="dialogEdit" persistent max-width="75%">
        <v-card v-if="showDelete">
            <v-card-title class="headline justify-space-between">
                Подтверждение удаления
            </v-card-title>
            <v-card-text>
                Вы действительно хотите удалить этот элемент? <br/>
                Это действие необратимо!
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" @click="deleteItem">Да, я хочу удалить</v-btn>
                <v-btn color="error" class="v-btn--save" @click="showDelete = false">Отменить</v-btn>
            </v-card-actions>
        </v-card>
        <v-card class="v-card--dialog" v-else>
            <v-card-title class="headline justify-space-between">
                Редактирование слайдера для карусели
                <v-btn color="error" class="v-btn--save" @click="showDelete = true">Удалить</v-btn>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-layout flex wrap>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Название</v-subheader>
                            <v-text-field
                                ref="slider_title"
                                v-model="slide.title"
                                v-validate="'required|max:50'"
                                data-vv-name="title"
                                :error-messages="errors.collect('title')"
                                single-line
                                text
                                solo
                                required/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-switch v-model="slide.status"
                                      :label="`${(slide.status || slide.status === 'ACTIVE') ? 'Активен' : 'Не активен' }`"/>
                        </v-flex>
                        <v-spacer/>
                        <upload-img :image-width="1920" :image-height="750" v-model="slide.img">
                            <div slot="activator">
                                <v-avatar size="100%" v-ripple tile
                                          v-if="typeof slide.img === 'object' && slide.img.imageURL">
                                    <img :src="slide.img.imageURL" alt="Изображение для слайдера"/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile
                                          v-else-if="typeof slide.img === 'string' && slide.img !== ''">
                                    <img :src="rootURL + slide.img" alt="Нажмите чтобы добавить картинку для слайдера"/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-else>
                                    <img src="/static/img/media/carousel_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для слайдера"/>
                                </v-avatar>
                            </div>
                        </upload-img>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Тип ссылки</v-subheader>
                            <v-combobox
                                :items="link_types"
                                label="Выберите тип ссылки"
                                text
                                solo
                                hide-selected
                                @change="getLinks"/>
                            <template v-if="slide.link_type < 4">
                                <v-subheader class="pa-0">{{ link_title }}</v-subheader>
                                <v-combobox
                                    v-if="slide.link_type < 3"
                                    :items="links"
                                    label="Выберите необходимое"
                                    text
                                    solo
                                    hide-selected
                                    item-value="id"
                                    item-text="name"
                                    @change="setLinkId">
                                    <template slot="no-data">
                                        <v-list-item>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    Пусто? Заполните нужный пункт и попробуйте снова
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </template>
                                </v-combobox>
                                <v-text-field
                                    v-if="slide.link_type === 3"
                                    v-model="slide.link"
                                    text
                                    solo
                                    single-line/>
                            </template>
                        </v-flex>
                        <v-spacer/>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Описание</v-subheader>
                            <v-textarea
                                ref="text"
                                v-model="slide.text"
                                v-validate="'required|max:255'"
                                :error-messages="errors.collect('text')"
                                data-vv-name="text"
                                single-line
                                text
                                solo
                                required
                                counter="255"/>
                        </v-flex>
                    </v-layout>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="save">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
                <v-btn color="error" class="v-btn--save" @click.native="onClose">Отмена</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import config from '../../../config'
    import UploadImg from '../../../components/Media/Upload'
    import Carousel from '../../../api/carousel'
    import Product from '../../../api/product'
    import Event from '../../../api/event'

    export default {
        name: 'editCarousel',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        props: {
            dialogEdit: { default: false },
            slide: { default: false },
            onClose: {
                default: () => {
                }
            },
        },
        data: () => ({
            loading: false,
            showDelete: false,
            loader: null,
            link_title: '',
            link_types: ['Продукт', 'Событие', 'Внешняя ссылка'],
            links: [],
            dictionary: {
                custom: {
                    title: {
                        required: 'Введите тайтл для слайдера',
                        max: 'Превышено максимальное количество символов'
                    },
                    text: {
                        required: 'Описание не заполнено',
                        max: 'Превышено максимальное количество символов'
                    }
                }
            },
            rootURL: ''
        }),
        mounted () {
            this.rootURL = config.rootPath
            this.$validator.localize('ru', this.dictionary)
        },
        watch: {
            dialogEdit (value) {
                if (!value) this.onClose()
            }
        },
        methods: {
            getLinks (value) {
                switch (value) {
                    case 'Продукт':
                        Product
                            .getAll()
                            .then(response => this.links = response.data.data)
                            .catch(error => new Error(error))

                        this.slide.link_type = 1
                        this.link_title = 'Выберите продукт'
                        break
                    case 'Событие':
                        Event
                            .getAll()
                            .then(response => this.links = response.data.data.items)
                            .catch(error => new Error(error))

                        this.slide.link_type = 2
                        this.link_title = 'Выберите событие'
                        break
                    case 'Внешняя ссылка':
                        this.slide.link = ''
                        this.slide.link_type = 3
                        this.link_title = 'Укажите ссылку'
                        break
                    default:
                        this.link_title = ''
                        this.slide.link = ''
                        this.slide.link_type = 4
                        break
                }
            },
            setLinkId (value) {
                this.slide.link = value.id
            },
            save () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true
                        Carousel
                            .edit(this.slide)
                            .then(response => {
                                this.$store.commit('showSnackbar', {
                                    text: response.data.data,
                                    color: 'success'
                                })
                                this.onClose()
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            },
            deleteItem () {
                Carousel
                    .delete(this.slide.id)
                    .then(response => {
                        this.$store.commit('showSnackbar', { text: response.data.data[Object.keys(response.data.data)[0]][0] })
                        this.onClose()
                    })
                    .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
            }
        }
    }
</script>

<style scoped>

</style>
